export const fr = [
  { _id: 'a-little-queens-huge-crown', name: "Couronne d'une petite reine", rarity: 5, role: 'warrior' },
  { _id: 'abyssal-crown', name: "Couronne de l'ab\u00eeme", rarity: 5, role: 'mage' },
  { _id: 'airtosurface-missile-misha', name: 'Missile air-sol : MIASH', rarity: 5, role: 'ranger' },
  { _id: 'alabastron', name: 'Alabastron', rarity: 5, role: 'assassin' },
  { _id: 'alencinoxs-wrath', name: "Col\u00e8re d'Alencinox", rarity: 5, role: 'warrior' },
  { _id: 'alexas-basket', name: "Panier d'Alexa", rarity: 5, role: 'assassin' },
  { _id: 'ancient-dragons-legacy', name: 'H\u00e9ritage du dragon antique', rarity: 5, role: 'knight' },
  { _id: 'bastion-of-perlutia', name: 'Citadelle de Perlutia', rarity: 5, role: 'knight' },
  { _id: 'black-hand-of-the-goddess', name: 'Main noire de la D\u00e9esse', rarity: 5, role: 'mage' },
  { _id: 'bloodseared-moon', name: 'Lune br\u00fbl\u00e9e par le sang', rarity: 5, role: '' },
  { _id: 'bloodstone', name: 'Pierre de sang', rarity: 5, role: 'ranger' },
  { _id: 'bloody-rose', name: 'Rose sanglante', rarity: 5, role: 'mage' },
  { _id: 'border-coin', name: 'Pi\u00e8ce frontali\u00e8re', rarity: 5, role: 'warrior' },
  { _id: 'celestine', name: 'C\u00e9lestine', rarity: 5, role: 'manauser' },
  { _id: 'champions-trophy', name: 'Troph\u00e9e du champion', rarity: 5, role: 'warrior' },
  { _id: 'chatty', name: 'Chatty', rarity: 5, role: 'mage' },
  { _id: 'circus-fantasia', name: 'Fantasia de cirque', rarity: 5, role: 'warrior' },
  { _id: 'cradle-of-life', name: 'Berceau de la vie', rarity: 5, role: 'warrior' },
  { _id: 'creation-destruction', name: 'Cr\u00e9ation & destruction', rarity: 5, role: 'warrior' },
  { _id: 'crimson-moon-of-nightmares', name: 'Lune de cauchemar pourpre', rarity: 5, role: 'mage' },
  { _id: 'crown-of-glory', name: 'Couronne de la gloire', rarity: 5, role: 'knight' },
  { _id: 'cruel-mischief', name: 'Farce atroce', rarity: 5, role: '' },
  { _id: 'dignus-orb', name: 'Orbe de Dignus', rarity: 5, role: 'mage' },
  { _id: 'doctors-bag', name: 'Kit de secours', rarity: 5, role: 'manauser' },
  { _id: 'doubleedged-decrescent', name: 'Decrescent \u00e0 double tranchant', rarity: 5, role: 'assassin' },
  { _id: 'draco-plate', name: 'Plaque draconique', rarity: 5, role: 'warrior' },
  { _id: 'durandal', name: 'Durandal', rarity: 5, role: 'warrior' },
  { _id: 'dux-noctis', name: 'Dux Noctis', rarity: 5, role: 'ranger' },
  { _id: 'elbris-ritual-sword', name: "\u00c9p\u00e9e rituelle d'Elbris", rarity: 5, role: 'knight' },
  { _id: 'eticas-scepter', name: "Sceptre d'Etica", rarity: 5, role: 'mage' },
  { _id: 'fairy-tale-for-a-nightmare', name: 'Conte cauchemardesque', rarity: 5, role: 'mage' },
  { _id: 'guiding-light', name: 'Lumi\u00e8re dirigeante', rarity: 5, role: 'ranger' },
  { _id: 'holy-sacrifice', name: 'Sacrifice sacr\u00e9', rarity: 5, role: 'knight' },
  { _id: 'idols-cheer', name: "Gaiet\u00e9 de l'idole", rarity: 5, role: 'manauser' },
  { _id: 'iron-fan', name: '\u00c9ventail de fer', rarity: 5, role: 'ranger' },
  { _id: 'junkyard-dog', name: 'Junkyard Dog', rarity: 5, role: 'warrior' },
  { _id: 'justice-for-all', name: 'Justice pour tous', rarity: 5, role: 'knight' },
  { _id: 'knowledge-seed', name: 'Graine du savoir', rarity: 5, role: 'mage' },
  { _id: 'last-teatime', name: 'Derni\u00e8re tasse de th\u00e9', rarity: 5, role: 'mage' },
  { _id: 'manica-of-control', name: 'Manica de contr\u00f4le', rarity: 5, role: 'assassin' },
  { _id: 'manifu', name: 'Manifu', rarity: 5, role: '' },
  { _id: 'merciless-glutton', name: 'Glouton impitoyable', rarity: 5, role: 'warrior' },
  { _id: 'ms-confille', name: 'Ms. Confille', rarity: 5, role: 'ranger' },
  { _id: 'necro-undine', name: 'Necro et Undine', rarity: 5, role: 'mage' },
  { _id: 'noble-oath', name: 'Noble serment', rarity: 5, role: 'knight' },
  { _id: 'otherworldly-machinery', name: 'Machine \u00e9th\u00e9r\u00e9e', rarity: 5, role: 'ranger' },
  { _id: 'proof-of-valor', name: 'Preuve de vaillance', rarity: 5, role: '' },
  { _id: 'reingars-special-drink', name: 'Nectar de Reingar', rarity: 5, role: 'ranger' },
  { _id: 'rhianna-luciella', name: 'Rhianna et Luciella', rarity: 5, role: 'assassin' },
  { _id: 'rise-of-a-monarch', name: "Naissance d'un monarque", rarity: 5, role: 'knight' },
  { _id: 'rod-of-amaryllis', name: "Tige d'Amaryllis", rarity: 5, role: 'manauser' },
  { _id: 'samsara-prayer-beads', name: 'Perles de samsara', rarity: 5, role: 'warrior' },
  {
    _id: 'secret-art-storm-sword',
    name: "M\u00e9thode de l'\u00e9p\u00e9e de temp\u00eate",
    rarity: 5,
    role: 'assassin',
  },
  { _id: 'shepherd-of-the-hollow', name: "Instigateur de l'oubli", rarity: 5, role: 'assassin' },
  { _id: 'shimadra-staff', name: 'B\u00e2ton de Shimadra', rarity: 5, role: 'manauser' },
  { _id: 'sigurd-scythe', name: 'Faux de Sigurd', rarity: 5, role: 'warrior' },
  { _id: 'snow-crystal', name: 'Cristal de neige', rarity: 5, role: 'warrior' },
  { _id: 'song-of-stars', name: 'Chanson des \u00e9toiles', rarity: 5, role: 'ranger' },
  { _id: 'spear-of-a-new-dawn', name: 'Lance du renouveau', rarity: 5, role: 'knight' },
  { _id: 'spirits-breath', name: "Souffle de l'esprit", rarity: 5, role: 'mage' },
  { _id: 'star-piercer', name: 'Cor de guerre', rarity: 5, role: '' },
  { _id: 'stella-harpa', name: 'Stella Harpa', rarity: 5, role: 'manauser' },
  { _id: 'sword-of-ezera', name: "\u00c9p\u00e9e d'Ezera", rarity: 5, role: 'knight' },
  { _id: 'sword-of-holy-light', name: '\u00c9p\u00e9e de la lumi\u00e8re sacr\u00e9e', rarity: 5, role: '' },
  { _id: 'sword-of-judgment', name: '\u00c9p\u00e9e du jugement', rarity: 5, role: 'ranger' },
  {
    _id: 'sword-of-summer-twilight',
    name: "\u00c9p\u00e9e cr\u00e9pusculaire d'\u00e9t\u00e9",
    rarity: 5,
    role: 'assassin',
  },
  { _id: 'time-matter', name: 'Substance de temps', rarity: 5, role: 'mage' },
  { _id: 'torn-sleeve', name: 'Manche d\u00e9chir\u00e9e', rarity: 5, role: 'assassin' },
  { _id: 'touch-of-rekos', name: 'Main de Rekos', rarity: 5, role: 'manauser' },
  { _id: 'twilight-calamity', name: 'Calamit\u00e9 du soleil couchant', rarity: 5, role: 'mage' },
  { _id: 'uberiuss-tooth', name: "Dent d'Uberius", rarity: 5, role: 'warrior' },
  { _id: 'unfading-memories', name: 'Souvenirs persistants', rarity: 5, role: 'manauser' },
  { _id: 'unseen-observer', name: 'Observateur invisible', rarity: 5, role: 'ranger' },
  { _id: 'violet-talisman', name: 'Talisman de Violet', rarity: 5, role: 'assassin' },
  { _id: 'wall-of-order', name: 'Obstacle de la discipline', rarity: 5, role: 'ranger' },
  { _id: 'war-horn', name: 'Cor de guerre', rarity: 5, role: '' },
  { _id: 'wind-rider', name: 'Cavalier du vent', rarity: 5, role: 'assassin' },
  { _id: 'adamant-shield', name: 'Bouclier inflexible', rarity: 4, role: 'knight' },
  { _id: 'ambrote', name: 'Ambrote', rarity: 4, role: 'ranger' },
  { _id: 'andres-crossbow', name: "Arbal\u00e8te d'Andr\u00e9", rarity: 4, role: 'ranger' },
  { _id: 'aurius', name: 'Aurius', rarity: 4, role: 'knight' },
  { _id: 'barthezs-orbuculum', name: 'Orbuculum de Barthez', rarity: 4, role: 'mage' },
  { _id: 'bloody-warhammer', name: 'Marteau de guerre sanglant', rarity: 4, role: '' },
  { _id: 'card-of-small-miracles', name: 'Carte des petits miracles', rarity: 4, role: '' },
  { _id: 'celestial-spear', name: 'Lance c\u00e9leste', rarity: 4, role: '' },
  { _id: 'crimson-seed', name: 'Graine pourpre', rarity: 4, role: 'warrior' },
  { _id: 'dust-devil', name: 'Diable de poussi\u00e8re', rarity: 4, role: 'assassin' },
  { _id: 'els-fist', name: "Poing d'El", rarity: 4, role: 'warrior' },
  { _id: 'elyhas-knife', name: "Couteau d'Elyha", rarity: 4, role: 'assassin' },
  { _id: 'eternus', name: '\u00c9ternus', rarity: 4, role: 'manauser' },
  { _id: 'flower-shower', name: 'Bain de fleurs', rarity: 4, role: 'warrior' },
  { _id: 'golden-cocoa-cookie', name: "Cookie de Cacao d'or", rarity: 4, role: '' },
  { _id: 'hell-cutter', name: 'Coupe-enfer', rarity: 4, role: 'warrior' },
  { _id: 'hilag-lance', name: "Lance d'Hilag", rarity: 4, role: 'knight' },
  { _id: 'iela-violin', name: "Violon d'Iela", rarity: 4, role: 'mage' },
  { _id: 'infinity-basket', name: 'Panier infini', rarity: 4, role: 'ranger' },
  { _id: 'kaladra', name: "Kal'adra", rarity: 4, role: 'mage' },
  { _id: 'love-potion', name: "Potion d'amour", rarity: 4, role: '' },
  { _id: 'magarahas-tome', name: 'Tome de Magaraha', rarity: 4, role: 'manauser' },
  { _id: 'midnight-bloom', name: 'Fleur de minuit', rarity: 4, role: '' },
  { _id: 'moonlight-dreamblade', name: 'R\u00eavelame lunaire', rarity: 4, role: 'assassin' },
  { _id: 'new-year-cookies', name: 'Biscuits du Nouvel an', rarity: 4, role: '' },
  { _id: 'one-year-of-gratitude', name: 'Une ann\u00e9e de gratitude', rarity: 4, role: '' },
  { _id: 'portrait-of-the-saviors', name: 'Portrait des sauveurs', rarity: 4, role: '' },
  { _id: 'radiant-forever', name: 'Perp\u00e9tuellement radieux', rarity: 4, role: 'mage' },
  { _id: 'rainbow-scale', name: '\u00c9caille arc-en-ciel', rarity: 4, role: '' },
  { _id: 'rosa-hargana', name: 'Rosa Hargana', rarity: 4, role: 'ranger' },
  { _id: 'santa-muerte', name: 'Santa Muerte', rarity: 4, role: 'assassin' },
  { _id: 'sashe-ithanes', name: 'Sashe Ithanes', rarity: 4, role: 'ranger' },
  { _id: 'sepulcrum', name: 'S\u00e9pulcre', rarity: 4, role: 'warrior' },
  { _id: 'shepherds-of-chaos', name: 'Bergers du chaos', rarity: 4, role: 'assassin' },
  { _id: 'silver-rain', name: 'Pluie soudaine', rarity: 4, role: 'assassin' },
  { _id: 'siraren', name: 'Sira-Ren', rarity: 4, role: 'mage' },
  { _id: 'spooky-solayu-stories', name: 'Histoires effrayantes de Solayu', rarity: 4, role: '' },
  { _id: 'steadfast-gatekeeper', name: 'Portier in\u00e9branlable', rarity: 4, role: 'knight' },
  { _id: 'strak-gauntlet', name: 'Gantelet de Strak', rarity: 4, role: 'warrior' },
  { _id: 'succubus-mirror', name: 'Miroir de la succube', rarity: 4, role: '' },
  { _id: 'tagehels-ancient-book', name: 'Livre ancien de Tagehel', rarity: 4, role: 'mage' },
  { _id: 'tear-of-the-desert', name: 'Larme du d\u00e9sert', rarity: 4, role: 'mage' },
  { _id: 'to-a-new-world', name: 'Pour une nouvelle \u00e8re', rarity: 4, role: '' },
  { _id: 'waters-origin', name: "Origine de l'eau", rarity: 4, role: 'manauser' },
  { _id: 'wondrous-potion-vial', name: 'Fiole de potion extraordinaire', rarity: 4, role: 'manauser' },
  { _id: 'xvi-the-tower', name: 'XVI. La Tour', rarity: 4, role: '' },
  { _id: 'alsacian-spear', name: "Lance d'Alsacia", rarity: 3, role: '' },
  { _id: 'ancient-sheath', name: 'Fourreau ancien', rarity: 3, role: '' },
  { _id: 'aqua-rose', name: 'Rose turquoise', rarity: 3, role: '' },
  { _id: 'ascending-axe', name: 'Hache ascendante', rarity: 3, role: '' },
  { _id: 'atmas-portal', name: "Portail d'Atma", rarity: 3, role: '' },
  { _id: 'butterfly-mandolin', name: 'Mandoline papillon', rarity: 3, role: '' },
  { _id: 'cursed-compass', name: 'Boussole maudite', rarity: 3, role: '' },
  { _id: 'daydream-joker', name: 'Joker de r\u00eaverie', rarity: 3, role: '' },
  { _id: 'devils-brand', name: 'Marque du diable', rarity: 3, role: '' },
  { _id: 'egg-of-delusion', name: "\u0152uf d'illusion", rarity: 3, role: '' },
  { _id: 'envoys-pipe', name: "Pipe de l'\u00e9missaire", rarity: 3, role: '' },
  { _id: 'exorcists-tonfa', name: "Tonfa d'exorciste", rarity: 3, role: '' },
  { _id: 'forest-totem', name: 'Totem de la for\u00eat', rarity: 3, role: '' },
  { _id: 'goblins-lamp', name: 'Lampe de gobelin', rarity: 3, role: '' },
  { _id: 'grail-of-blood', name: 'Graal de sang', rarity: 3, role: '' },
  { _id: 'labyrinth-cube', name: 'Cube du labyrinthe', rarity: 3, role: '' },
  { _id: 'mighty-yaksha', name: 'Redoutable Yaksha', rarity: 3, role: '' },
  { _id: 'oath-key', name: 'Cl\u00e9 de serment', rarity: 3, role: '' },
  { _id: 'prophetic-candlestick', name: 'Chandelier proph\u00e9tique', rarity: 3, role: '' },
  { _id: 'ranons-memorandum', name: 'M\u00e9morandum de Ranon', rarity: 3, role: '' },
  { _id: 'ruby-essence', name: 'Essence de rubis', rarity: 3, role: '' },
  { _id: 'sword-of-the-morning', name: '\u00c9p\u00e9e du matin', rarity: 3, role: '' },
  { _id: 'timeless-anchor', name: 'Ancre intemporelle', rarity: 3, role: '' },
];
